type PollingQuery = {
  options: { pollInterval?: number };
  getCurrentResult(): { loading: boolean };
  refetch(): Promise<unknown>;
};

/** Skip hidden-tab polls and refresh active polling queries once when returning. */
export function createVisiblePolling(
  document: Document,
  activeQueries: () => Iterable<PollingQuery>,
): { skipPollAttempt: () => boolean; destroy: () => void } {
  let wasHidden = document.hidden;
  const onVisibilityChange = () => {
    const resumed = wasHidden && !document.hidden;
    wasHidden = document.hidden;
    if (!resumed) return;
    for (const query of activeQueries()) {
      if (
        (query.options.pollInterval ?? 0) > 0 &&
        !query.getCurrentResult().loading
      ) {
        // Apollo's normal error link and query result handle errors. Polling continues.
        void query.refetch().catch(() => undefined);
      }
    }
  };
  document.addEventListener('visibilitychange', onVisibilityChange);
  return {
    skipPollAttempt: () => document.hidden,
    destroy: () =>
      document.removeEventListener('visibilitychange', onVisibilityChange),
  };
}
